import { createTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

// MUI theme — palette values must be concrete hex/rgb (createTheme runs in JS,
// before the browser resolves CSS variables). Hex values here mirror the
// primitives defined in tokens/primitives.css; semantic.css var(--color-*)
// tokens remain the source of truth for all styled-components and sx props.
//
// Two concrete palettes (light/dark) are built from the same shape so plain
// MUI components (Select, TextField, MenuItem, ...) that don't receive an
// explicit sx color still track the app's light/dark toggle — see
// useIsDarkMode() / App.tsx, which pick between them at runtime. The dark
// values mirror ascend-tokens.css's `html.dark-mode:root` block.
export function createQuantStudioTheme(mode: 'light' | 'dark'): Theme {
  const isDark = mode === 'dark';
  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? '#4AABE0' : '#1976d2',   // --accessible-blue
        dark: isDark ? '#2A8FBF' : '#1565c0',   // --blue-dark
      },
      error: {
        main: '#c62828',       // --prim-color-red-500
      },
      warning: {
        main: '#f57c00',       // --prim-color-amber-500
      },
      success: {
        main: isDark ? '#4CAF50' : '#2e7d32',   // --accessible-green
      },
      background: {
        default: isDark ? '#1A1A1A' : '#ffffff',  // --surface
        paper: isDark ? '#2C2C2A' : '#ffffff',    // --white
      },
      text: {
        primary: isDark ? '#F2F2F2' : '#212121',   // --jet
        secondary: isDark ? '#A7A8AA' : '#616161', // --cg-11
      },
      divider: isDark ? '#3A3A38' : '#D0D0CE',     // --cg-2
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: 14,
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        defaultProps: {
          elevation: 0,
        },
      },
    },
  });
}

export const quantStudioTheme = createQuantStudioTheme('light');
export const quantStudioDarkTheme = createQuantStudioTheme('dark');
